<template>
  <v-row dense>
    <v-col cols="12" sm="6">
      <px-select-enum
        dense
        label="Campo"
        class="required rounded-tag-small"
        :error="$v.criterio.campo.$error"
        @blur="$v.criterio.campo.$touch()"
        v-model="criterio.campo"
        :items="opcoesCriterios"
        @change="onChangeCampo"
      />
    </v-col>
    <v-col cols="12" sm="6" class="d-flex">
      <px-criterio
        :tipo-criterio="criterio.campo"
        :metadata="criterioMetadata"
        :error="$v.criterio.values.$error"
        :criterios-enum="criteriosEnum"
        @blur="$v.criterio.values.$touch()"
        v-model="criterio.values"
      />
      <v-btn icon @click="onClickRemove">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import PxCriterio from '@/modules/alcadas/components/criterios/PxCriterio.vue';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    criterio: Object,
    opcoesCriterios: Array,
    criteriosEnum: Array,
  },
  methods: {
    onClickRemove() {
      this.$emit('remove');
    },
    onChangeCampo() {
      this.criterio.values = null;
    },
    isValid() {
      return !this.validateForm();
    },
  },
  computed: {
    criterioMetadata() {
      const opcaoCriterio = this.opcoesCriterios.find(item => item.key === this.criterio.campo);
      if (opcaoCriterio && opcaoCriterio.type) {
        return {
          type: opcaoCriterio.type,
          label: opcaoCriterio.description,
        };
      }
      return null;
    },
  },
  components: {
    PxCriterio,
  },
  validations: {
    criterio: {
      campo: {
        required,
      },
      values: {
        required,
      },
    },
  },
};
</script>
